const defaultState = {
  referralsNumber: 0
};

const configParametersActionTypes = {
  SET_REFERRALS_NUMBER: 'SET_REFERRALS_NUMBER',
};

const referralsActions = function (state = defaultState, { type, payload }) {
  switch (type) {
    case configParametersActionTypes.SET_REFERRALS_NUMBER:
      return {
        ...state,
        referralsNumber: payload
      };
    default:
      return state;
  }
};

export default referralsActions;

// ACTIONS
export const setReferralsNumber = payload => ({
  type: configParametersActionTypes.SET_REFERRALS_NUMBER,
  payload
});